// Template Generated by DataExtraction.py at 1716507313
        
import ThirdPartyEnglish from "../../Forms/Third Party/ThirdParty_English.png";
import ThirdPartyEnglishLabels from "../../Labels/Third Party/ThirdParty_English.json";
import ThirdPartyFrench from "../../Forms/Third Party/ThirdParty_French.png";
import ThirdPartyFrenchLabels from "../../Labels/Third Party/ThirdParty_French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ThirdPartyFrenchLabels : ThirdPartyEnglishLabels;
    const formImage = isFrench ? ThirdPartyFrench : ThirdPartyEnglish;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;
    const kyc = data.knowYourClient;

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;

    let subNames = subscriber.firstName + (subscriber.lastName ? " " + subscriber.lastName : "");

    if (common.subscriber2Include){
        subNames += " & " + jointSubscriber.firstName + (jointSubscriber.lastName ? " " + jointSubscriber.lastName : "")
    }

    // Drawing the form
    drawText(common.agentName, "drFullName");
    drawText(moment().format("yyyy-MM-DD"), "formDate");
    drawText(subNames, "subFullNames");
    drawText(subNames, "subFullNames2");
    drawText(kyc.thirdPartyApproxNetWorth, "thirdPartyApproxNetWorth"); // should be a function?
    drawText(kyc.thirdPartyBegin, "thirdPartyBegin"); // not a date?
    drawText(moment(kyc.thirdPartyBirthdate).format("yyyy-MM-DD"), "thirdPartyBirthdate"); // wrong date format?
    drawText(kyc.thirdPartyDetail, "thirdPartyDetail");
    drawText(kyc.thirdPartyDisposableIncome, "thirdPartyDisposableIncome");
    drawText(kyc.thirdPartyDocumentation, "thirdPartyDocumentation");
    drawText(moment(kyc.thirdPartyEndDate).format("yyyy-MM-DD"), "thirdPartyEndDate"); // wrong date format?
    drawText(kyc.thirdPartyHomeAddress, "thirdPartyHomeAddress");
    drawText(kyc.thirdPartyIdExpiry, "thirdPartyIdExpiry");
    drawText(kyc.thirdPartyIdNumber, "thirdPartyIdNumber");
    drawText(kyc.thirdPartyIdType, "thirdPartyIdType");
    drawText(kyc.thirdPartyIncome, "thirdPartyIncome");
    drawText(kyc.thirdPartyIncomeSource, "thirdPartyIncomeSource");
    drawText(kyc.thirdPartyName, "thirdPartyName");
    drawText(kyc.thirdPartyNoEndReason, "thirdPartyNoEndReason");
    drawText(kyc.thirdPartyRelationship, "thirdPartyRelationship");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ThirdPartyFrenchLabels : ThirdPartyEnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    const thirdPartyRecipientId = POSSIBLE_SIGNERS['Third Party'];
    let signers = [];
    let signHereTabs = [];
    
    
    // fsSignature
    signers.push({
        [thirdPartyRecipientId]: [signatureTab(thirdPartyRecipientId, documentId, pageNumber, signatureLabel("fsSignature", labels))],
    });
    
    
    // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignature", labels))],
    });
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    